import React, { useState } from 'react';
import { Button } from 'primereact/button';

export const ChatJourney = ({ currentJourneyNode, parentJourneyNode, onJourneyChoice, onJourneyBack, onTalkToShopOwner }) => {
    const [isDisabled, setIsDisabled] = useState(false);

    if (!currentJourneyNode) return null;

    const handleTalkToShopOwner = () => {
        setIsDisabled(true);
        onTalkToShopOwner();
    };

    const isLeafNode = !currentJourneyNode.children || currentJourneyNode.children.length === 0;

    return (
        <div className="quick-replies">
            <div className="quick-replies-title">Choose one of the options below:</div>

            {isLeafNode ? (
                <>
                    {currentJourneyNode.key !== '0' && (
                        <Button
                            label="⬅️ Back to previous"
                            className="p-button-sm p-button-secondary"
                            onClick={onJourneyBack}
                            disabled={isDisabled}
                        />
                    )}
                    <Button
                        label="💬 Talk to shop representative"
                        className="p-button-sm p-button-help p-button-primary"
                        onClick={handleTalkToShopOwner}
                        disabled={isDisabled}
                    />
                </>
            ) : (
                <>
                    {currentJourneyNode.children.map(child => (
                        <Button
                            key={child.key}
                            label={child.data.question}
                            className="p-button-sm p-button-text"
                            onClick={() => onJourneyChoice(child)}
                            disabled={isDisabled}
                        />
                    ))}
                    {currentJourneyNode.key !== '0' && (
                        <Button
                            label="⬅️ Back to previous"
                            className="p-button-sm p-button-outlined"
                            onClick={onJourneyBack}
                            disabled={isDisabled}
                        />
                    )}
                    <Button
                        label="💬 Talk to shop representative"
                        className="p-button-sm p-button-help p-button-primary"
                        onClick={handleTalkToShopOwner}
                        disabled={isDisabled}
                    />
                </>
            )}
        </div>
    );
};
